import React, { useState } from 'react';
import './checkbox.scss';
import {generateUniqueId} from "../../../app/functions";

const Checkbox = (props) => {
    const [checked, setChecked] = useState(false);

    const handleOnChange = (e) => {
        if(e) {
            e.stopPropagation();
        }
        const isChecked = value !== '' ? value : checked;
        props.onChange(!isChecked);
        setChecked(!isChecked);
    };

    const {
        name,
        label = '',
        value = '',
        showError = false,
        errorMessage = '',
        tabIndex,
        id = ('id' + Math.floor(Math.random() * 10000000)),
        className = '',
        checked_img = '',
        not_checked_img = '',
        onLabelClick = () => {},
        onLinkClick = () => {},
    } = props;

    const handleLabelClick = (e) => {
        if (e) {
            e.stopPropagation();
        }
        typeof onLabelClick === 'function' && onLabelClick();
    };

    const handleLinkClick = (e) => {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        typeof onLinkClick === 'function' && onLinkClick();
    };

    const getTemplate = () => {
        const res = [];
        const startOfTemplate = label.indexOf('{');
        const endOfTemplate = label.indexOf('}');
        res.push(
            <span key={generateUniqueId(15)}>
                {label.slice(0, startOfTemplate)}
            </span>
        );
        res.push(
            <a className='use-terms' key={generateUniqueId(15)} href={'#'} onClick={handleLinkClick}>
                {label.slice(startOfTemplate + 1, endOfTemplate)}
            </a>
        );
        res.push(
            <span key={generateUniqueId(15)}>
                {label.slice(endOfTemplate + 1)}
            </span>
        );
        return res;
    };

    const isChecked = value !== '' ? value : checked
    const isTemplate = typeof label === 'string' && label.match(/\{([^}]+)\}/g);
    const newLabel = isTemplate ? getTemplate() : label;
    return (
        <div className = {'checkbox_wrapper ' + className}>
            <img src={isChecked ? checked_img : not_checked_img} alt="Checkbox" onClick={handleOnChange} />
            <input type        = {'checkbox'}
                   name        = { name }
                   id          = { id }
                   value       = { value }
                   onChange    = { handleOnChange }
                   tabIndex    = { tabIndex }
            />
            <label htmlFor = {id} onClick={handleLabelClick}>{ newLabel }</label>
            {showError ? <div className = "error_text">{ errorMessage }</div> : ''}
        </div>
    )
}
export default Checkbox;

